import axios from './axios';

const API_URL = '/api/v1/settings';

export const getSettings = async () => {
  return await axios.get(API_URL);
};

export const updateSettings = async (settings) => {
  return await axios.put(API_URL, { settings });
};

export const updateSocietyInfo = async (payload) => {
  return await axios.put(API_URL, payload);
};
